export enum ContainerEventType {
  ON_LAYOUT_CHANGE = 'onLayoutChange',
  ON_READY_STATE_CHANGE = 'onReadyStateChange',
  ON_CONTAINER_ERROR = 'onContainerError',
}
